<template>
  <div>
    <validation-observer ref="form">
      <!-- Start and Area -->
      <template>
        <div
          class="d-flex justify-content-end mb-1 mt-2"
          id="fixed-buttons"
          :class="{ fixed: isFixed }"
        >
          <b-button
            v-if="edit === true"
            :variant="isFixed ? 'warning' : 'outline-warning'"
            class="mr-1"
            @click="editEmployeeBasicInformation"
          >
            <feather-icon icon="Edit2Icon" class="mr-50" />
            {{ $t("EDIT") }}
          </b-button>

          <b-button
            v-if="edit === false"
            :variant="isFixed ? 'success' : 'outline-success'"
            class="mr-1"
            @click="updateJobDetails"
          >
            <feather-icon icon="SaveIcon" class="mr-50" />
            {{ $t("SAVE") }}
          </b-button>

          <b-button
            v-if="edit === false"
            :variant="isFixed ? 'danger' : 'outline-danger'"
            class="mr-1"
            @click="refresh"
          >
            {{ $t("CANCEL") }}
          </b-button>
        </div>

        <b-card>
          <template #header>
            <b-card-title class="title-uwu">
              {{ $t("START & DEPARTMENT") }}
            </b-card-title>
          </template>

          <template #default>
            <b-row>
              <!-- Empresa -->
              <b-col lg="4" xl="4" md="6" sm="6" xs="12">
                <validation-provider v-slot="{ errors }" name="empresa_id">
                  <b-form-group
                    label="Empresa"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      v-model="userData.empresa_id"
                      placeholder="Seleccionar Empresa"
                      id="empresa_id"
                      :disabled="edit"
                      :clearable="!edit"
                      :reduce="(value) => value.id"
                      label="razon_social"
                      :options="empresas"
                    >
                      <template #selected-option="{ razon_social }">
                        <span class="text-truncate">{{ razon_social }}</span>
                      </template>
                    </v-select>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Personal Type -->
              <b-col lg="4" xl="4" md="6" sm="6" xs="12">
                <validation-provider v-slot="{ errors }" name="personal_type">
                  <b-form-group
                    :label="$t('Personal Type')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      v-model="userData.personal_type"
                      :placeholder="$t('Select a Personal Type')"
                      id="personal_type"
                      :disabled="edit"
                      :clearable="!edit"
                      :reduce="(value) => value.id"
                      label="value"
                      :options="personalTypes"
                    >
                      <template #selected-option="{ value }">
                        <span class="text-truncate">{{ value }}</span>
                      </template>
                    </v-select>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Personal Type -->
              <b-col
                lg="4"
                xl="4"
                md="6"
                sm="6"
                xs="12"
                v-if="userData.personal_type == 4"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="stever_type"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('Stever Type')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      v-model="userData.stever_type"
                      :placeholder="$t('Select a stever type')"
                      id="stever_type"
                      :disabled="edit"
                      :clearable="!edit"
                      :reduce="(value) => value.id"
                      label="value"
                      :options="stevedoreTypes"
                    >
                      <template #selected-option="{ value }">
                        <span class="text-truncate">{{ value }}</span>
                      </template>
                    </v-select>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Entity Group-->
              <b-col lg="4" xl="4" md="6" sm="6" xs="12">
                <validation-provider v-slot="{ errors }" name="entity_group">
                  <b-form-group
                    :label="$t('Entity Group')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      v-model="userData.entity_group_id"
                      id="entity_group"
                      :disabled="edit"
                      :clearable="!edit"
                      label="text"
                      :options="entityGroups"
                      :reduce="(value) => value.value"
                    >
                      <template #selected-option="{ text }">
                        <span class="text-truncate">{{ text }}</span>
                      </template>
                    </v-select>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Service -->
              <b-col
                lg="4"
                xl="4"
                md="6"
                sm="6"
                xs="12"
                v-if="userData.personal_type == 2"
              >
                <validation-provider v-slot="{ errors }" name="service_type">
                  <b-form-group
                    :label="$t('Service Type')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      v-model="userData.service_type"
                      :placeholder="$t('Select a service type')"
                      id="service_type"
                      :disabled="edit"
                      :clearable="!edit"
                      :reduce="(value) => value.id"
                      label="value"
                      :options="serviceTypes"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Bonus -->
              <b-col
                lg="4"
                xl="4"
                md="6"
                sm="6"
                xs="12"
                class="mt-1"
                v-if="userData.personal_type == 2"
              >
                <validation-provider v-slot="{ errors }" name="bonus">
                  <!-- <span class="text-primary" style="float: right">
                    <span class="text-danger">Total: </span>
                    <span class="text-primary">
                      S/ {{ totalBonus | currency }}
                    </span>
                  </span> -->
                  <b-form-group
                    :label="$t('Bonus')"
                    label-for="bonus"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      v-model="userData.bonus"
                      :placeholder="$t('Select if apply bonus')"
                      :reduce="(val) => val.id"
                      id="bonus"
                      :disabled="edit"
                      label="value"
                      :options="bono"
                    >
                      <template #selected-option="{ value }">
                        <feather-icon
                          class="text-success"
                          icon="ChevronsRightIcon"
                          size="18"
                        />
                        <span style="margin-left: 0.5rem">{{ value }}</span>
                      </template>
                      <template #option="{ value }">
                        <feather-icon
                          class="text-success"
                          icon="ChevronsRightIcon"
                          size="18"
                        />
                        <span style="margin-left: 0.5rem">{{ value }}</span>
                      </template>
                    </v-select>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Category -->
              <b-col
                lg="4"
                xl="4"
                md="6"
                sm="6"
                xs="12"
                class="mt-1"
                v-if="userData.personal_type == 2"
              >
                <validation-provider v-slot="{ errors }" name="category">
                  <b-form-group
                    :label="$t('Category')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      :clearable="!edit"
                      v-model="userData.category"
                      :placeholder="$t('Select a category')"
                      id="category"
                      :disabled="edit"
                      :reduce="(value) => value.id"
                      label="value"
                      :options="categories"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- UT Type -->
              <b-col
                lg="4"
                xl="4"
                md="6"
                sm="6"
                xs="12"
                class="mt-1"
                v-if="userData.personal_type == 2"
              >
                <validation-provider v-slot="{ errors }" name="ut_type">
                  <b-form-group
                    :label="$t('UT Type')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      id="ut_type"
                      :clearable="!edit"
                      v-model="userData.ut_type"
                      :placeholder="$t('Select a UT type')"
                      :disabled="edit"
                      :reduce="(value) => value.id"
                      label="value"
                      :options="ut_types"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Start Date -->
              <b-col
                lg="4"
                xl="4"
                md="6"
                sm="6"
                xs="12"
                :class="[userData.personal_type == 2 ? 'mt-1' : 'mt-1']"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="start_date"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('Start Date')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <kendo-datepicker
                      v-if="finishedLoading"
                      id="start_date"
                      v-model="userData.start_date"
                      v-mask="'##/##/####'"
                      class="form-control-kendo"
                      :class="[
                        isDarkSkin ? ' bg-transparent' : '',
                        '',
                        errors[0] ? 'border-danger' : '',
                      ]"
                      :format="'MM/dd/yyyy'"
                      :disabled="edit"
                      @change="userData.end_date = null"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Month quantity -->
              <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                <b-form-group :label="$t('Month quantity')">
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <v-select
                    v-if="finishedLoading"
                    id="month_qty"
                    v-model="userData.month_qty"
                    :reduce="(value) => value.id"
                    label="name"
                    :options="monthQuantityOptions"
                    placeholder="Select months quantity"
                    @input="changeMonthQuantity"
                  />
                </b-form-group>
              </b-col>

              <!-- End Date -->
              <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                <validation-provider
                  v-slot="{ errors }"
                  name="end_date"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('End Date')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <kendo-datepicker
                      v-if="finishedLoading"
                      id="end_date"
                      v-model="userData.end_date"
                      v-mask="'##/##/####'"
                      class="form-control-kendo"
                      :class="[
                        isDarkSkin ? ' bg-transparent' : '',
                        '',
                        errors[0] ? 'border-danger' : '',
                      ]"
                      :format="'MM/dd/yyyy'"
                      :disabled="true"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Area-->
              <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                <validation-provider v-slot="{ errors }" name="area">
                  <b-form-group
                    :label="$t('Area')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      id="area"
                      v-model="userData.department_id"
                      :disabled="edit"
                      :reduce="(value) => value.id"
                      label="name"
                      :options="departments"
                      :clearable="!edit"
                      @input="getRolByDepartment"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Rol -->
              <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                <validation-provider v-slot="{ errors }" name="rol">
                  <b-form-group
                    :label="$t('Rol')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      v-model="userData.rol_id"
                      id="rol"
                      :disabled="edit"
                      :reduce="(value) => value.id"
                      label="name"
                      :options="optionsRol"
                      :clearable="!edit"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Observation-->
              <b-col lg="12" xl="12" md="12" sm="12" xs="12" class="mt-1">
                <validation-provider name="observation">
                  <b-form-group :label="$t('Observation')">
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <b-textarea
                      v-if="finishedLoading"
                      id="observation"
                      v-model="userData.observation"
                      :disabled="edit"
                      no-resize
                      rows="1"
                      max-rows="1"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </template>
        </b-card>
      </template>

      <!-- ATTENDANCE -->
      <template>
        <b-card>
          <template #header>
            <b-card-title class="title-uwu w-100">
              <div class="d-flex justify-content-between">
                <span>{{ $t("ATTENDANCE") }}</span>
                <feather-icon
                  v-if="userData.attendance_id != null"
                  class="cursor-pointer text-success"
                  icon="ListIcon"
                  size="23"
                  v-b-tooltip.hover.right="$t('Viatics Tracking')"
                  @click="openViaticTrackingModal"
                />
                <feather-icon
                  v-if="userData.attendance_id == null && !edit"
                  class="cursor-pointer text-primary"
                  size="23"
                  icon="RepeatIcon"
                  v-b-tooltip.hover.right="$t('Generate Code')"
                  @click="generateCodeAttendance"
                />
              </div>
            </b-card-title>
          </template>
          <template #default>
            <b-row>
              <!-- Code-->
              <b-col lg="6" xl="6" md="6" sm="6" xs="12">
                <b-form-group :label="$t('Code')">
                  <b-skeleton v-if="!finishedLoading" type="input" />
                  <b-form-input
                    v-if="finishedLoading"
                    id="code"
                    :value="userData.code"
                    class="text-warning font-weight-bold"
                    :disabled="true"
                  />
                </b-form-group>
              </b-col>

              <!-- Viatics -->
              <b-col lg="6" xl="6" md="6" sm="6" xs="12">
                <validation-provider v-slot="{ errors }" name="is_viatic">
                  <b-form-group
                    :label="$t('Viatics')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      v-model="userData.is_viatic"
                      :placeholder="$t('Select if apply bonus')"
                      id="is_viatic"
                      :disabled="edit"
                      :clearable="!edit"
                      :reduce="(value) => value.id"
                      label="value"
                      :options="viaticOptions"
                    >
                      <template #selected-option="{ id, value }">
                        <feather-icon
                          :class="id == 1 ? 'text-success' : 'text-danger'"
                          :icon="id == 1 ? 'CheckIcon' : 'XCircleIcon'"
                          size="18"
                        />
                        <span style="margin-left: 0.8rem">{{ $t(value) }}</span>
                      </template>
                      <template #option="{ id, value }">
                        <feather-icon
                          :class="id == 1 ? 'text-success' : 'text-danger'"
                          :icon="id == 1 ? 'CheckIcon' : 'XCircleIcon'"
                          size="18"
                        />
                        <span style="margin-left: 0.8rem">{{ $t(value) }}</span>
                      </template>
                    </v-select>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Requiere marca de asistencia -->
              <b-col lg="6" xl="6" md="6" sm="6" xs="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="apply_attendance"
                >
                  <b-form-group
                    :label="$t('Marca de Asistencia')"
                    :state="errors[0] ? false : null"
                  >
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      v-if="finishedLoading"
                      v-model="userData.apply_attendance"
                      placeholder="¿Necesita marca de asistencia?"
                      id="apply_attendance"
                      :disabled="edit"
                      :clearable="!edit"
                      :reduce="(value) => value.id"
                      label="value"
                      :options="[
                        { id: 1, value: 'Sí' },
                        { id: 0, value: 'No' },
                      ]"
                    >
                      <template #selected-option="{ id, value }">
                        <feather-icon
                          :class="id == 1 ? 'text-success' : 'text-danger'"
                          :icon="id == 1 ? 'CheckIcon' : 'XCircleIcon'"
                          size="18"
                        />
                        <span style="margin-left: 0.8rem">{{ $t(value) }}</span>
                      </template>
                      <template #option="{ id, value }">
                        <feather-icon
                          :class="id == 1 ? 'text-success' : 'text-danger'"
                          :icon="id == 1 ? 'CheckIcon' : 'XCircleIcon'"
                          size="18"
                        />
                        <span style="margin-left: 0.8rem">{{ $t(value) }}</span>
                      </template>
                    </v-select>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </template>
        </b-card>
      </template>

      <!-- SALARY -->
      <template>
        <b-card>
          <template #header>
            <b-card-title class="title-uwu w-100">
              <div class="d-flex justify-content-between">
                <span>{{ $t("SALARY") }}</span>
                <feather-icon
                  class="cursor-pointer text-success"
                  icon="ListIcon"
                  size="23"
                  v-b-tooltip.hover.right="$t('Salary Tracking')"
                  @click="openSalaryTrackingModal"
                />
              </div>
            </b-card-title>
          </template>
          <template #default>
            <b-row>
              <b-col>
                <b-row>
                  <!-- Type Form-->
                  <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                    <validation-provider v-slot="{ errors }" name="type_form">
                      <b-form-group
                        :label="$t('Type Form')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="type_form"
                          v-model="userData.type_form"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="value"
                          :options="types_form"
                          :clearable="!edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Type Form-->
                  <b-col
                    lg="4"
                    xl="4"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                    v-if="userData.type_form != null"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="labor_regime"
                    >
                      <b-form-group
                        :label="$t('Labor Regime')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="labor_regime"
                          v-model="userData.labor_regime_id"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="name"
                          :options="labor_regimes"
                          :clearable="!edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- <b-col
                    lg="4"
                    xl="4"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                    v-if="userData.type_form != 2 && userData.type_form != null"
                  >
                    <validation-provider v-slot="{ errors }" name="extra">
                      <b-form-group
                        :label="$t('Type')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="extra"
                          v-model="userData.type"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="value"
                          :options="types"
                          :clearable="!edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col> -->

                  <!-- Pension Fund -->
                  <b-col
                    lg="4"
                    xl="4"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                    v-if="userData.type_form != 2 && userData.type_form != null"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="pension_fund"
                    >
                      <b-form-group
                        :label="$t('Pension Fund')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="pension_fund"
                          v-model="userData.pension_fund_id"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="name"
                          :options="pension_fund"
                          :clearable="!edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Tipo comision -->
                  <b-col
                    lg="4"
                    xl="4"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                    v-if="userData.type_form != 2 && userData.type_form != null"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="tipo_comision"
                    >
                      <b-form-group
                        :label="'Tipo Comision'"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="tipo_comision"
                          v-model="userData.tipo_comision"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="name"
                          :options="tipos_comision"
                          :clearable="!edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- CUSPP -->
                  <b-col
                    lg="4"
                    xl="4"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                    v-if="esPlanilla"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="cuspp"
                    >
                      <b-form-group
                        label="CUSPP"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <b-form-input
                          v-if="finishedLoading"
                          id="cuspp"
                          v-model="userData.cuspp"
                          :disabled="edit"
                          placeholder="Ingrese CUSPP (12 caracteres)"
                          maxlength="12"
                          :formatter="(val) => (val || '').toUpperCase()"
                          trim
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Payment Method-->
                  <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                    <validation-provider
                      v-slot="{ errors }"
                      name="payment_method"
                    >
                      <b-form-group
                        :label="$t('Payment Method')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="payment_method"
                          v-model="userData.payment_method"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="name"
                          :options="payment_methods"
                          :clearable="!edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Type of agreement-->
                  <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                    <validation-provider
                      v-slot="{ errors }"
                      name="type_of_agreement"
                    >
                      <b-form-group
                        :label="$t('Type of Agreement')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="type_of_agreement"
                          v-model="userData.type_of_agreement"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="value"
                          :clearable="!edit"
                          :options="agreement_types"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- CURRENCY-->
                  <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                    <validation-provider v-slot="{ errors }" name="currency">
                      <b-form-group
                        :label="$t('Currency')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="currency"
                          v-model="userData.currency"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="name"
                          :clearable="!edit"
                          :options="optionsCurrency"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Salary -->
                  <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                    <validation-provider v-slot="{ errors }" name="salary">
                      <b-form-group
                        :label="$t('Salary')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <money
                          v-if="finishedLoading"
                          v-model="userData.salary"
                          v-bind="{
                            decimal: '.',
                            thousands: ',',
                            prefix: prefix,
                            precision: 2,
                            masked: false,
                          }"
                          class="form-control form-control-md"
                          disabled
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Bonification -->
                  <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                    <validation-provider
                      v-slot="{ errors }"
                      name="bonification"
                    >
                      <b-form-group
                        :label="$t('Bonification')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <money
                          v-if="finishedLoading"
                          v-model="userData.bonification"
                          v-bind="{
                            decimal: '.',
                            thousands: ',',
                            prefix: prefix,
                            precision: 2,
                            masked: false,
                          }"
                          class="form-control form-control-md"
                          disabled
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                    <validation-provider
                      v-slot="{ errors }"
                      name="asignacion_familiar"
                    >
                      <b-form-group
                        label="Asignacion Familiar"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <money
                          v-if="finishedLoading"
                          v-model="userData.asignacion_familiar"
                          v-bind="{
                            decimal: '.',
                            thousands: ',',
                            prefix: prefix,
                            precision: 2,
                            masked: false,
                          }"
                          class="form-control form-control-md"
                          :disabled="edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                    <validation-provider
                      v-slot="{ errors }"
                      name="asignacion_alimentaria"
                    >
                      <b-form-group
                        label="Asignacion Alimentaria"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <money
                          v-if="finishedLoading"
                          v-model="userData.asignacion_alimentaria"
                          v-bind="{
                            decimal: '.',
                            thousands: ',',
                            prefix: prefix,
                            precision: 2,
                            masked: false,
                          }"
                          class="form-control form-control-md"
                          :disabled="edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row v-if="tieneOtraRemuneracion">
                  <div class="job-detail-divider"></div>
                </b-row>

                <!-- Doble Pago -->
                <b-row>
                  <b-col
                    v-if="esPlanilla"
                    lg="2"
                    xl="2"
                    md="6"
                    sm="6"
                    class="mt-1"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="tiene_otro_pago"
                    >
                      <b-form-group
                        :state="errors[0] ? false : null"
                        label="¿Tiene otro pago?"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <b-form-checkbox
                          v-if="finishedLoading"
                          id="tiene_otro_pago"
                          v-model="userData.tiene_otro_pago"
                          :disabled="edit"
                          switch
                          class="d-flex align-items-center"
                          value="1"
                          unchecked-value="0"
                        >
                        </b-form-checkbox>
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Type Form-->
                  <b-col
                    v-if="tieneOtraRemuneracion && esPlanilla"
                    lg="2"
                    xl="2"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="or_type_form"
                    >
                      <b-form-group
                        :label="$t('Type Form')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="or_type_form"
                          v-model="userData.or_type_form"
                          disabled
                          :reduce="(value) => value.id"
                          label="value"
                          :options="types_form"
                          :clearable="!edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Labor Regime -->
                  <b-col
                    v-if="tieneOtraRemuneracion && esPlanilla"
                    lg="2"
                    xl="2"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="or_labor_regime"
                    >
                      <b-form-group
                        :label="$t('Labor Regime')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="or_labor_regime"
                          v-model="userData.or_labor_regime_id"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="name"
                          :options="labor_regimes"
                          :clearable="!edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Payment Method-->
                  <b-col
                    v-if="tieneOtraRemuneracion && esPlanilla"
                    lg="2"
                    xl="2"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="or_payment_method"
                    >
                      <b-form-group
                        :label="$t('Payment Method')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="or_payment_method"
                          v-model="userData.or_payment_method"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="name"
                          :options="payment_methods"
                          :clearable="!edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Type of agreement-->
                  <b-col
                    v-if="tieneOtraRemuneracion && esPlanilla"
                    lg="2"
                    xl="2"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="or_type_of_agreement"
                    >
                      <b-form-group
                        :label="$t('Type of Agreement')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="or_type_of_agreement"
                          v-model="userData.or_type_of_agreement"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="value"
                          :clearable="!edit"
                          :options="agreement_types"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- CURRENCY-->
                  <b-col
                    v-if="tieneOtraRemuneracion && esPlanilla"
                    lg="2"
                    xl="2"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                  >
                    <validation-provider v-slot="{ errors }" name="or_currency">
                      <b-form-group
                        :label="$t('Currency')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <v-select
                          v-if="finishedLoading"
                          id="or_currency"
                          v-model="userData.or_currency"
                          :disabled="edit"
                          :reduce="(value) => value.id"
                          label="name"
                          :clearable="!edit"
                          :options="optionsCurrency"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Salary -->
                  <b-col
                    v-if="tieneOtraRemuneracion && esPlanilla"
                    lg="2"
                    xl="2"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                  >
                    <validation-provider v-slot="{ errors }" name="or_salary">
                      <b-form-group
                        :label="$t('Salary')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <money
                          id="or_salary"
                          v-if="finishedLoading"
                          v-model="userData.or_salary"
                          v-bind="{
                            decimal: '.',
                            thousands: ',',
                            prefix: prefix,
                            precision: 2,
                            masked: false,
                          }"
                          class="form-control form-control-md"
                          :disabled="edit"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <!-- Bonification -->
                  <b-col
                    v-if="tieneOtraRemuneracion && esPlanilla"
                    lg="2"
                    xl="2"
                    md="6"
                    sm="6"
                    xs="12"
                    class="mt-1"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="or_bonification"
                    >
                      <b-form-group
                        :label="$t('Bonification')"
                        :state="errors[0] ? false : null"
                      >
                        <b-skeleton v-if="!finishedLoading" type="input" />
                        <money
                          id="or_bonification"
                          v-if="finishedLoading"
                          v-model="userData.or_bonification"
                          v-bind="{
                            decimal: '.',
                            thousands: ',',
                            prefix: prefix,
                            precision: 2,
                            masked: false,
                          }"
                          :disabled="edit"
                          class="form-control form-control-md"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </template>
        </b-card>
      </template>

      <!-- Laboral Regime -->
      <!-- <template>
        <b-card>
          <template #header>
            <b-card-title class="title-uwu w-100">
              <div class="d-flex justify-content-between">
                <span>{{ $t("Laboral Regime") }}</span>
              </div>
            </b-card-title>
          </template>
          <template #default>
            <b-row>
              <b-col>
                <b-row> </b-row>
              </b-col>
            </b-row>
          </template>
        </b-card>
      </template> -->
    </validation-observer>

    <ViaticTrackingModal
      v-if="viaticTrackingModal"
      :dataModal="dataModal"
      @hideModal="viaticTrackingModal = false"
    />
    <SalaryTrackingModal
      v-if="salaryTrackingModal"
      :dataModal="dataModal"
      @close="salaryTrackingModal = false"
    />
  </div>
</template>
<script>
import vSelect from "vue-select";
import EmployeesService from "@/views/rrhh/views/employees/services/employee.service.js";
import { mapGetters } from "vuex";
import { createPopper } from "@popperjs/core";
import moment from "moment";

import ViaticTrackingModal from "@/views/rrhh/views/employees/components/modal/ViaticTrackingModal.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import SettingPayroll from "@/views/settings/views/payroll/services/setting-payroll.service.js";
import TiposAcuerdosService from "@/views/settings/views/payroll/components/tipos-acuerdos/service/tipos-acuerdos.service.js";
// import TrackingJobDetails from "@/views/management/views/employees/employees-module/employees-list/modals/options/job-details/modals/Tracking/TrackingJobDetails";
import SalaryTrackingModal from "@/views/rrhh/views/employees/components/modal/SalaryTrackingModal.vue";
export default {
  components: {
    vSelect,
    ViaticTrackingModal,
    SalaryTrackingModal,
    // TrackingJobDetails,
  },
  data() {
    return {
      finishedLoading: false,
      modalTracking: false,
      entityGroups: [],
      // Se carga desde Ajustes > Planilla > Tipos de Acuerdo
      agreement_types: [],
      personalTypes: [
        { id: 1, value: this.$t("Employee") },
        { id: 2, value: this.$t("Driver") },
        { id: 3, value: this.$t("Third Party") },
        { id: 4, value: this.$t("Stevedore") },
      ],
      stevedoreTypes: [
        { id: 1, value: "ESTIBADOR LOCAL" }, //26
        { id: 2, value: "ESTIBADOR NESTLE" }, //26
        { id: 3, value: "ESTIBADOR AREQUIPA" }, //30
      ],
      serviceTypes: [
        { id: 1, value: "Nacional" },
        { id: 2, value: "Local" },
        { id: 3, value: "Campaña" },
      ],
      bono: [
        { id: 1, value: "SI" },
        { id: 2, value: "NO" },
      ],
      viaticOptions: [
        { id: 1, value: "Apply" },
        { id: 2, value: "Not Apply" },
      ],
      types: [
        { id: 1, value: "AFP" },
        { id: 2, value: "ONP" },
      ],
      categories: [
        { id: 1, value: "A" },
        { id: 2, value: "B" },
      ],
      types_form: [
        { id: 1, value: "Planilla" },
        { id: 2, value: "R x H" },
      ],
      optionsRol: [],
      ut_types: [
        { id: 1, value: "Camion Carreta" },
        { id: 2, value: "C - Camión" },
        { id: 3, value: "TS - Tracto Semiremolque" },
        { id: 4, value: "CR - Camión Remolque" },
      ],
      status: [
        { status: 1, name: "Active" },
        { status: 2, name: "Inactive" },
      ],
      optionsCurrency: [
        { id: 1, name: "$ (Dollar)" },
        { id: 2, name: "S./ (Soles)" },
      ],
      optionsMethod: [
        { method: 1, name: "Transfer" },
        { method: 2, name: "Check" },
      ],
      payment_methods: [
        { id: 1, name: "Quincenal" },
        { id: 2, name: "Mensual" },
      ],
      userData: {
        file: "",
        currency: 1,
        salary: 0,
        month_qty: null,
        empresa_id: null,
        tiene_otro_pago: false,
        cuspp: null,
      },
      valor: "0.00",
      image: null,
      edit: true,
      changeInput: null,
      noModifyUserData: [],
      jobDetailsRefresh: [],
      labor_regimes: [],
      viaticTrackingModal: false,
      salaryTrackingModal: false,
      dataModal: {},
      isFixed: false,
      pension_fund: [],
      tipos_comision: [
        { id: "flujo", name: "FLUJO" },
        { id: "mixto", name: "MIXTO" },
      ],
      monthQuantityOptions: [
        { id: "1", name: "3 months", qty: 3 },
        { id: "2", name: "6 months", qty: 6 },
        { id: "3", name: "12 months", qty: 12 },
      ],
      departments: [],
      empresas: [],
    };
  },

  computed: {
    esPlanilla() {
      return this.userData.type_form == 1;
    },
    tieneOtraRemuneracion() {
      return this.userData.tiene_otro_pago == 1;
    },
    prefix() {
      return this.userData.currency === 1
        ? "$"
        : this.userData.currency === 2
        ? "S/."
        : "$";
    },
    prefixCurrency() {
      return this.userData.currency_provision === 1
        ? "$"
        : this.userData.currency_provision === 2
        ? "S/."
        : "$";
    },
    // totalBonus() {
    //   let total = 0;
    //   this.bono.map((b) => {
    //     if (this.userData.bonus) {
    //       const isBono = this.userData.bonus.find((bb) => bb == b.id);
    //       if (isBono) total += parseFloat(b.amount);
    //     }
    //   });
    //   return total;
    // },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    prefixProvision() {
      return this.userData.currency_provision === 1
        ? "$"
        : this.userData.currency_provision === 2
        ? "S/."
        : "$";
    },

    pension_fund_filtered() {
      if (this.userData.type === 1) {
        return this.pension_fund.filter(
          (item) =>
            item.id === 2 ||
            item.id === 3 ||
            item.id === 4 ||
            item.id === 5 ||
            item.id === 6
        );
      } else {
        return this.pension_fund.filter((item) => item.id === 1);
      }
    },
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  async created() {
    try {
      await Promise.all([
        this.getJobDetailsEmployeer(),
        this.getAllAreas(),
        this.getRolByDepartment(),
        this.getEntityGroups(),
        this.getLaborRegimes(),
        this.getPensionFund(),
        this.getEmpresas(),
        this.getTiposAcuerdo(),

        // this.getBonusForSelect(),
      ]);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
    this.finishedLoading = true;
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      var scrollPosition = window.scrollY || document.documentElement.scrollTop;
      this.isFixed = scrollPosition > 450;
    },
    async getTiposAcuerdo() {
      try {
        const data = await TiposAcuerdosService.list({ all: true });
        this.agreement_types = data.map((item) => ({
          id: item.id,
          value: item.nombre,
        }));
      } catch (error) {
        console.error(error);
      }
    },
    openTrackingModal() {
      this.modalTracking = true;
    },
    closeTrackingModal() {
      this.modalTracking = false;
    },
    calculatePorcentage() {
      if (this.userData.percentage_provision >= 100) {
        this.userData.percentage_provision = 100;
      }
      this.userData.provision =
        (this.userData.salary * this.userData.percentage_provision) / 100;
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: "top",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1],
            },
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              );
            },
          },
        ],
      });
      return () => popper.destroy();
    },
    changeMonthQuantity() {
      let startDate = moment(this.userData.start_date);
      let monthQty = this.monthQuantityOptions.find(
        (opt) => opt.id == this.userData.month_qty
      )?.qty;
      let finishDate = startDate.add(monthQty, "months");
      finishDate = finishDate.format("YYYY-MM-DD");
      this.userData.end_date = finishDate;
    },
    async getPensionFund() {
      try {
        const { data } = await SettingPayroll.getPensionFundSetting();
        this.pension_fund = data;
        return this.pension_fund;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async getEmpresas() {
      try {
        const { data } = await SettingPayroll.getEmpresas();
        this.empresas = data;
        return this.empresas;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async getAllRelations() {
      try {
        const data = await EmployeesService.getAllRelations();

        // eslint-disable-next-line no-param-reassign

        this.relations = data.data;
        // Must return an array of items or an empty array if an error occurred

        return this.relations;
      } catch (e) {
        // this.showErrorSwal(e);
        console.log(e);
        return [];
      }
    },
    async getAllDocuments() {
      try {
        this.addPreloader();
        const { data } = await EmployeesService.getAllDocumentTypes();
        this.document = data;
        return this.document;
      } catch (e) {
        // this.showErrorSwal(e);
        console.log(e);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    async getAllMartial() {
      try {
        this.addPreloader();
        const { data } = await EmployeesService.getAllMartial();
        this.martial = data.data;
        return this.martial;
      } catch (e) {
        // this.showErrorSwal(e);
        console.log(e);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    async getAllAreas() {
      try {
        this.addPreloader();
        const { data } = await EmployeesService.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.departments = data;
        return this.departments;
      } catch (e) {
        // this.showErrorSwal(e);
        console.log(e);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    async getRolByDepartment() {
      if (!this.userData.department_id) return;
      try {
        const params = {
          id: this.userData.department_id,
        };
        const { data } = await EmployeesService.getRolByDepartment(params);
        this.optionsRol = data;
        return this.optionsRol;
      } catch (e) {
        // this.showErrorSwal(e);
        console.log(e);
        return [];
      }
    },
    async editEmployeeBasicInformation() {
      this.edit = !this.edit;
    },

    async updateJobDetails() {
      try {
        const result = await this.$refs.form.validate();
        if (result) {
          if (
            this.esPlanilla &&
            this.userData.cuspp &&
            this.userData.cuspp.trim() &&
            !/^[A-Z0-9\u00D1]{12}$/i.test(this.userData.cuspp.trim())
          ) {
            this.showToastError(
              "El CUSPP debe tener 12 caracteres (letras y números)."
            );
            return;
          }
          const response = await this.showConfirmSwal();
          if (response.isConfirmed) {
            this.addPreloader();

            let params = {
              id: this.$route.params.id,
              // salary_id: this.userData.salary_id,
              attendance_id: this.userData.attendance_id,
              personal_type: this.userData.personal_type,
              stever_type: this.userData.stever_type,
              entity_group: this.userData.entity_group_id,
              service_type: this.userData.service_type,
              bonus: this.userData.bonus,
              category: this.userData.category,
              ut_type: this.userData.ut_type,
              start_date: moment(this.userData.start_date).format("YYYY-MM-DD"),
              end_date: moment(this.userData.end_date).format("YYYY-MM-DD"),
              department_id: this.userData.department_id,
              rol_id: this.userData.rol_id,
              observation: this.userData.observation,
              is_viatic: this.userData.is_viatic,
              payment_method: this.userData.payment_method,
              type_of_agreement: this.userData.type_of_agreement,
              currency: this.userData.currency,
              salary: this.userData.salary,
              bonification: this.userData.bonification,
              asignacion_familiar: this.userData.asignacion_familiar,
              asignacion_alimentaria: this.userData.asignacion_alimentaria,
              user_id: this.currentUser.id,
              type_form: this.userData.type_form,
              labor_regime_id: this.userData.labor_regime_id,
              empresa_id: this.userData.empresa_id,
              tipo_comision: this.userData.tipo_comision,
              cuspp: this.esPlanilla
                ? (this.userData.cuspp && this.userData.cuspp.trim()
                    ? this.userData.cuspp.trim().toUpperCase()
                    : null)
                : null,
              apply_attendance: this.userData.apply_attendance,

              // 🔹 otro pago directo con ternario
              tiene_otro_pago:
                this.userData.tiene_otro_pago == 1 && this.esPlanilla ? 1 : 0,
              or_type_form:
                this.userData.tiene_otro_pago == 1 && this.esPlanilla
                  ? this.userData.or_type_form
                  : null,
              or_labor_regime_id:
                this.userData.tiene_otro_pago == 1 && this.esPlanilla
                  ? this.userData.or_labor_regime_id
                  : null,
              or_payment_method:
                this.userData.tiene_otro_pago == 1 && this.esPlanilla
                  ? this.userData.or_payment_method
                  : null,
              or_type_of_agreement:
                this.userData.tiene_otro_pago == 1 && this.esPlanilla
                  ? this.userData.or_type_of_agreement
                  : null,
              or_currency:
                this.userData.tiene_otro_pago == 1 && this.esPlanilla
                  ? this.userData.or_currency
                  : null,
              or_salary:
                this.userData.tiene_otro_pago == 1 && this.esPlanilla
                  ? this.userData.or_salary || 0
                  : 0,
              or_bonification:
                this.userData.tiene_otro_pago == 1 && this.esPlanilla
                  ? this.userData.or_bonification || 0
                  : 0,
            };

            if (this.userData.type_form == 2) {
              params.pension_fund_id = null;
            } else {
              params.pension_fund_id = this.userData.pension_fund_id;
            }

            const data = await EmployeesService.updateJobDetails(params);
            if (data.status === 200) {
              await this.getJobDetailsEmployeer();
              this.refresh();
              this.showToastSuccess(data.message);
            }
          }
        }
      } catch (e) {
        // this.showErrorSwal(e);
        this.showToastError(e.response?.data);
        console.log(e);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    refresh() {
      this.edit = true;
      this.userData = { ...this.noModifyUserData };
    },

    async getJobDetailsEmployeer() {
      try {
        this.addPreloader();
        const params = { id: this.$route.params.id };
        const data = await EmployeesService.getJobDetailsInformation(params);
        this.noModifyUserData = { ...data.data[0] };
        this.userData = data.data[0];
        this.userData.salary = Number(this.userData.salary);
        await this.getRolByDepartment(); // <--- aquí es importante poner el await

        this.userData.salary = this.userData.salary || 0;
        this.userData.bonification = this.userData.bonification || 0;
        this.userData.asignacion_familiar =
          this.userData.asignacion_familiar || 0;
        this.userData.asignacion_alimentaria =
          this.userData.asignacion_alimentaria || 0;
        this.userData.current_provision = this.userData.current_provision || 0;
        this.userData.initial_provision = this.userData.initial_provision || 0;

        this.userData.type = [2, 3, 4, 5, 6].includes(
          this.userData.pension_fund_id
        )
          ? 1
          : 2;

        this.userData.or_salary = Number(this.userData.or_salary) || 0;
        this.userData.or_bonification =
          Number(this.userData.or_bonification) || 0;
        this.userData.tiene_otro_pago = this.userData.tiene_otro_pago;
        this.userData.cuspp = this.userData.cuspp || null;

        return this.userData;
      } catch (e) {
        console.log(e);
        return [];
      } finally {
        this.removePreloader();
      }
    },

    changePersonalType() {
      // this.getBonusForSelect();
      if (this.userData.personal_type != 2) {
        this.userData.service_type = null;
        // this.userData.bono = null;
        this.userData.license_number = null;
        this.userData.ut_type = null;
      }
      if (this.userData.personal_type != 4) {
        this.userData.stever_type = null;
      }
    },
    async getEntityGroups() {
      try {
        const { data } = await EmployeesService.getEntitiesGroup();
        this.entityGroups = data;
        return this.entityGroups;
      } catch (error) {
        console.log(error);
        return [];
      }
    },

    // async getBonusForSelect() {
    //   if (!this.userData.personal_type) return [];
    //   try {
    //     const params = { type: this.userData.personal_type };
    //     const { data } = await EmployeesService.getBonusForSelect(params);
    //     this.bono = data;
    //     return this.bono;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    async getLaborRegimes() {
      try {
        const { data } = await EmployeesService.getLaborRegimes();
        this.labor_regimes = data;
        return this.labor_regimes;
      } catch (error) {
        console.log(error);
      }
    },

    openViaticTrackingModal() {
      this.dataModal = {
        code: this.userData.code,
        attendance_id: this.userData.attendance_id,
      };
      this.viaticTrackingModal = true;
    },
    openSalaryTrackingModal() {
      this.salaryTrackingModal = true;
    },
    async generateCodeAttendance() {
      try {
        if (this.userData.is_viatic == null || this.userData.is_viatic == "") {
          this.$toast({
            component: ToastificationContent,
            position: "top-center",
            props: {
              title: this.$t("Error"),
              icon: "BellIcon",
              variant: "danger",
              text: "Debe seleccionar viatico.",
            },
          });
          this.$toast;
          return;
        }
        const confirm = await this.showConfirmSwal();
        if (confirm.isConfirmed) {
          const { data } = await EmployeesService.generateCodeAttendance({
            employee_id: this.$route.params.id,
            is_viatic: this.userData.is_viatic,
          });

          if (data.type === "warning") {
            this.$toast({
              component: ToastificationContent,
              position: "top-center",
              props: {
                title: this.$t("Advertencia"),
                icon: "BellIcon",
                variant: "warning",
                text: data.message,
              },
            });
            this.$toast;
            return;
          } else if (data.type === "success") {
            this.$toast({
              component: ToastificationContent,
              position: "top-center",
              props: {
                title: this.$t("Success"),
                icon: "CheckIcon",
                variant: "success",
                text: data.message,
              },
            });
          }
          this.userData.attendance_id = data.attendance_id;
          this.userData.code = data.code;
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: "top-center",
          props: {
            title: this.$t("Error"),
            icon: "BellIcon",
            variant: "danger",
            text: error,
          },
        });
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement="top"] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}

#overpx .vs__dropdown-toggle .vs__selected-options .vs__search {
  margin: 9.15px 0 0 !important;
}

.title_lable {
  width: 200px;
}

@media (max-width: 1366px) {
  .space {
    width: 47.5% !important;
  }

  .title_lable {
    width: 183px;
  }
}

@media (max-width: 1024px) {
  .space {
    width: auto;
  }

  .title_lable {
    width: 183px;
  }
}

.custom-caro.k-input {
  max-width: 218px !important;
  width: 300px !important;
}

.custom-caro2.k-input {
  max-width: 322px !important;
  width: 322px !important;
}

// .vs__search {
//   display: none !important;
// }

#fixed-buttons {
  position: relative;
}

#fixed-buttons.fixed {
  position: fixed;
  top: 10vh;
  right: 1.5vw;
  z-index: 1000;
}

.job-detail-divider {
  width: 100%;
  margin: 2.5rem 0; /* más espacio entre secciones */
  border: none;
  border-top: 2px solid #e0e0e0; /* línea clara y fina */
}

.dark-layout .job-detail-divider {
  border-top-color: #555; /* tono gris oscuro en dark mode */
}
</style>
